import React, { useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { API_URL } from '..';

const toNumber = (v) => (isNaN(v) || v === null ? 0 : Number(v));
const formatMoney = (v) => `£${toNumber(v).toFixed(2)}`;
const StockListLayer = ({jobsData}) => {
  const history = useNavigate();
  const [currentUser, setCurrentUser]= useState({})
      const handleDelete = async(id)=>{
      
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
         let response = await fetch(API_URL+`/api/invoice/stock/single-delete/${id}`, { 
           method: "DELETE",
           headers: headersList
         });
         let data = await response.json();
         if(data.message=="success"){
            window.location.reload();
         }
      }
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'))
      setCurrentUser(user)
        const table = $('#dataTable').DataTable({
        data: jobsData,
        responsive:true,
        pageLength: 10,
         columns: [
            { data: 'title' },
            { data: 'costPrice',render:function (data, type, row){
              return `<span>${formatMoney(data)}</span>`
            } },
            { data: 'sellPrice',render:function (data, type, row){
              return `<span>${formatMoney(data)}</span>`
            } },
            { data: 'quantity' },
           
            {
              data: null, // Indicates this column is generated using the `render` function
              render: function (data, type, row) {
                // Return HTML string for buttons
                return `
                <div class="dropdown">
                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ph ph-list"></i>
                </button>
                <ul class="dropdown-menu">
                  <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View </a></li>
                  <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit </a></li>
                  <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete </a></li>
                </ul>
              </div>
                
                `;
              },
              title: 'Actions', // The header for the column
              orderable: false // Optional: Prevent sorting on this column
            }
        ]
            
        });
        $('#dataTable tbody').on('click', '.edit-btn', function () {
          const id = $(this).data('id');
          history(`/stock/edit/${id}`); // Navigate to the edit page
        });
        $('#dataTable tbody').on('click', '.view-btn', function () {
          const id = $(this).data('id');
          history(`/stock/view/${id}`); // Navigate to the edit page
        });
    
        // Event listener for delete button
        $('#dataTable tbody').on('click', '.delete-btn', function () {
          const id = $(this).data('id');
          handleDelete(id); // Call the delete function
        });
        return () => {
            table.destroy(true);
        };
    }, [jobsData]);

    return (
        <div className="card basic-data-table">
        <div className="card-header">
          <div className="row">
            <h5 className="col-md-6 card-title mb-0"></h5>
            <div class="col-md-6 text-end">
            <Link className="btn btn-info" to={'/add-stock'}>
              Add New
            </Link>
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className="table bordered-table mb-0" id="dataTable">
            <thead>
              <tr>
           
                <th scope="col">Title</th>
                <th scope="col">Cost Price</th>
                <th scope="col">Sell Price</th>
             
                <th scope="col">Quantity</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {/* DataTables will populate this tbody */}
            </tbody>
          </table>
        </div>
      </div>
    )
}

export default StockListLayer